//
// Javascript for LoginControl
//
//  Ben Ramey
//  October 2009
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.LoginControl = function()
{
  var $loginControl = $("div.login-control");

  if ($loginControl.length == 0)
    return;

  this.loginBtn = $("a.button[id$=Login]");
  this.formMessages = HEIJS.page.formMessages.getHandler($loginControl.parents('div.form').attr('id'));

  this.setFocus();
  this.setupEvents();

  if ($("span.failure-text").text() != "")
  {
    this.formMessages.showErrorMessage($("span.failure-text").text());
  }
};

HEIJS.Controls.LoginControl.prototype =
{
  //
  // Properties
  //
  loginBtn: null,
  formMessages: null,

  //
  // Methods
  //
  setFocus: function()
  {
    var userNameInput = $("input[id$=UserName]");
    var passwordInput = $("input[id$=Password]");

    // focus the username input if it is empty
    if (userNameInput.val().length <= 0)
    {
      userNameInput.focus();
    }
    // focus the passwordInput if userNameInput is not empty
    else
    {
      passwordInput.focus();
    }
  },

  handleInputKeyPress: function(e)
  {
    if (e.which == 13)
    {
      this.loginBtn.click(); // get's the status message up but does not go to the href location
	  var js = this.loginBtn.attr("href");
	  if (js) eval(js.replace("javascript:", ""));
    }
  },

  setupEvents: function()
  {
    var self = this;

    $("input[id$=Password],input[id$=UserName], input[id$=RememberMe]").keypress(
      function(e) { self.handleInputKeyPress(e); }
    );

    $("input[id$=Password]").keypress(
      function(e)
      {
        if (self.isCapsLockOn(e))
        {
          self.formMessages.showInfoMessage("Warning: Caps Lock is on!", -1);
        }
        else
        {
          self.formMessages.hideInfoMessages();
        }
      }
    );
  },

  isCapsLockOn: function(e)
  {
    var charCode;
    if (e.which)
    {
      charCode = e.which;
    }
    else if (e.keyCode)
    {
      charCode = e.keyCode;
    }

    var shiftOn = false;
    if (e.shiftKey)
    {
      shiftOn = e.shiftKey;
    }
    else if (e.modifiers)
    {
      shiftOn = !!(e.modifiers & 4);
    }

    // lowercase letters
    if (charCode >= 97 && charCode <= 122 && shiftOn)
    {
      return true;
    }

    // uppercase letters
    if (charCode >= 65 && charCode <= 90 && !shiftOn)
    {
      return true;
    }

    return false;
  }
};

$(document).ready(
  function()
  {
    HEIJS.page.loginControl = new HEIJS.Controls.LoginControl();
  }
);